import { render, staticRenderFns } from "./PackageFormDialog.vue?vue&type=template&id=00a88c3c"
import script from "./PackageFormDialog.vue?vue&type=script&lang=js"
export * from "./PackageFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports